import type { PageReadinessState } from './page-readiness-browser'

/** Callers pass current-view gates, never retained results from an older view. */
export function resolvePageReadinessState(options: {
  loading?: boolean
  failed?: boolean
  partial?: boolean
  empty?: boolean
  unavailable?: boolean
}): PageReadinessState {
  if (options.unavailable) {
    return 'unavailable'
  }
  if (options.failed) {
    return 'error'
  }
  if (options.loading) {
    return 'loading'
  }
  if (options.partial) {
    return 'partial'
  }
  return options.empty ? 'empty' : 'ready'
}
